import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';

export const MyAssetLeftSectionContainer = styled.div`
  min-height: 600px;
  width: 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 20px;
  background: transparent;
  gap: 10px;

  @media ${media.desktop} {
    min-height: 500px;
    width: 100%;
    max-width: 100%;

    .recharts-wrapper {
      max-height: 500px !important;
      min-height: 500px !important;
    }
  }

  @media ${media.mobile} {
    min-height: 0;
    padding: 0px 20px;
  }

  .recharts-wrapper {
    filter: drop-shadow(0 4px 20px rgba(0, 0, 0, 0.1));
  }
`;

export const MyAssetRightSectionContainer = styled.div`
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  box-sizing: border-box;
  gap: 20px;

  .recharts-default-legend{
    display: flex !important;
    gap: 20px !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .recharts-legend-item{
    margin-right: 0 !important;
  }

  @media ${media.desktop} {
    width: 100%;
    height: auto;
  }

  @media ${media.mobile} {
    padding: 20px;
  }
`;

export const PnlSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: transparent;
  border-radius: 16px;
  border: ${({ theme }) => `1px solid ${theme.COLORS.tableBtn}`};
  backdrop-filter: blur(10px);
`;

export const PnlSummaryItem = styled.div<{ isProfit: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  padding: 12px 16px;
  background: ${(props) =>
    props.isProfit ? 'rgba(34, 197, 94, 0.08)' : 'rgba(239, 68, 68, 0.08)'};
  border-radius: 12px;
  border: 1px solid
    ${(props) =>
      props.isProfit ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)'};

  .label {
    font-size: 14px;
    font-weight: 500;
    opacity: 0.9;
  }

  .value {
    font-size: 16px;
    font-weight: 700;
  }
`;

export const PnlChartContainer = styled.div`
  flex: 1;
  min-height: 300px;
  padding: 20px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.COLORS.tableBtn};
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;

  .recharts-wrapper {
    filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1));
  }

  @media ${media.desktop} {
    min-height: 250px;
  }
`;
export const MyAssetBothSection = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;

  @media ${media.desktop} {
    flex-direction: column;
    align-items: center;
  }

  @media ${media.mobile} {
    padding: 0;
  }
`;

export const ChartCenterInfo = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;

  .total-label {
    font-size: 14px;
    font-weight: 500;
    opacity: 0.8;
    margin-bottom: 5px;
  }

  .total-value {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 3px;
  }

  .total-currency {
    font-size: 12px;
    opacity: 0.7;
  }
`;

export const ChartLegendContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;

  @media ${media.desktop} {
    gap: 20px;
  }

  @media ${media.mobile} {
    flex-direction: column;
    gap: 10px;
  }
`;

export const LegendItem = styled.button<{ color: string }>`
  flex:1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: ${({ theme }) => theme.COLORS.cardOpacity};
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.COLORS.tableBtn};
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  cursor: pointer;

  @media ${media.mobile} {
    width: 100%;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .legend-color {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: ${(props) => props.color};
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
    flex-shrink: 0;
  }

  .legend-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;

    .legend-name {
      font-size: 16px;
      font-weight: 600;
    }

    .legend-value {
      font-size: 14px;
      opacity: 0.8;
      font-weight: 500;
      text-align: left;
    }
  }
`;
